<template>
    <span class="px-2.5 py-1 text-blue-200 dark:text-blue-70 bg-blue-70/15 dark:bg-blue-630 text-xxs leading-[12px] rounded-2.5 font-medium capitalize">
        Beta
    </span>
</template>
